import { createReducer, updateState } from "redux/handlers"
import types from './types'

const initialState = {
  chatmailSync: []
}

const updateChatmailSync = (state, action) => {
  return updateState(state, {
    chatmailSync: action.chatmailSync,
  })
}


export default createReducer(initialState, {
  [types.UPDATE_CHATMAIL_SYNC]: updateChatmailSync
})